import React, { useContext } from 'react';
import { FetchUserCompanyDetails } from '@shared/api/dto/UserCompanyDetails';
import { Common } from '../../static/Messages';
import countries from '../../locale/countries.json';
import DataCard from '../dataCard/DataCard';
import { MessageContext } from '../../locale/MessageProvider';
import { Button } from 'is24-corecss';

type CompanyDetailsProps = {
  companyDetails?: FetchUserCompanyDetails;
  onEdit: () => void;
  className?: string;
};

enum fieldName {
  title,
  vatNumber,
}

const CompanyDetails: React.FC<CompanyDetailsProps> = ({ companyDetails, onEdit, className }: CompanyDetailsProps) => {
  const messageFormatter = useContext(MessageContext);

  const countryName = (): string => {
    return countries.find((item) => item.code === companyDetails?.country)?.value || companyDetails?.country || '';
  };

  const parseUrl = () => {
    if (companyDetails?.url?.startsWith('http')) {
      return companyDetails?.url;
    }
    return '//' + companyDetails?.url;
  };

  return (
    <DataCard
      title={messageFormatter.formatMessage(CompanyDetails, fieldName[fieldName.title])}
      className={className}
      button={
        <Button data-testid="data-card-button-company-details" textStyle={true} onClick={onEdit}>
          <span className="is24-icon-edit "></span>
          {' ' + messageFormatter.formatCommonMessage(Common.edit).toLowerCase()}
        </Button>
      }
    >
      {companyDetails && (
        <div className="grid grid-flex">
          <p className="one-whole padding-top-s">{companyDetails?.name}</p>
          <p className="one-whole padding-top-s">{companyDetails?.street + ' ' + companyDetails?.houseNumber}</p>
          <p className="one-whole">{companyDetails?.zipCode + ' ' + companyDetails?.city}</p>
          <p className="one-whole">{countryName()}</p>
          <p className="one-whole padding-top-s">{companyDetails?.phoneNumber}</p>
          <p className="one-whole padding-top-s">
            <a href={parseUrl()} className="with-icon" target="_blank">
              {companyDetails?.url}
            </a>
          </p>
          <p className="one-whole padding-top-s">{companyDetails?.email}</p>
          <p className="one-whole padding-top-s">
            {companyDetails?.vatNumber &&
              `${messageFormatter.formatMessage(
                CompanyDetails,
                fieldName[fieldName.vatNumber],
              )} ${companyDetails?.vatNumber}`}
          </p>
        </div>
      )}
    </DataCard>
  );
};

export default CompanyDetails;
